import { UserRole } from "../constants/user-roles";
import { DASHBOARD_ROUTE } from "../constants/pages-routes";

function maybePrependRegion(regionSlug: string | null | undefined, path: string): string {
    if (!regionSlug) {
        return path;
    }

    const normalizedPath = path === "/" ? "" : path;
    return `/${regionSlug}${normalizedPath}`;
}

/**
 * Determines the appropriate redirect route after login based on user role and currentStep
 * @param role - The user's role
 * @param regionSlug - Optional region slug to prepend to region-aware routes
 * @param currentStep - Optional current step of registration (if 1, redirect to profile for volunteers)
 * @returns The route path to redirect to
 */
export function getPostLoginRedirectRoute(role: UserRole, regionSlug?: string | null, currentStep?: number): string {
    // Volunteers and Homeowners with currentStep=1 must complete profile first
    if ((role === UserRole.VOLUNTEER || role === UserRole.HOMEOWNER) && currentStep === 1) {
        return "/profile";
    }
    
    switch (role) {
        case UserRole.Supporter:
            return maybePrependRegion(regionSlug, DASHBOARD_ROUTE.reports);
        case UserRole.TEAM_LEADER:
        case UserRole.VOLUNTEER:
            // Volunteers and Team Leaders land on Hub
            return maybePrependRegion(regionSlug, DASHBOARD_ROUTE.base); // base = "/base" (Hub)
        case UserRole.ADMIN:
        case UserRole.BASE_LEADER:
        case UserRole.PARTNER:
            // Admin, Base Leader, Partner go to homeowners page
            return maybePrependRegion(regionSlug, DASHBOARD_ROUTE.dashboard); // dashboard = "/homeowners"
        case UserRole.HOMEOWNER:
            // Homeowners go to homeowners page
            return maybePrependRegion(regionSlug, DASHBOARD_ROUTE.dashboard); // dashboard = "/homeowners"
        default:
            // Fallback to homeowners page for any unknown roles
            return maybePrependRegion(regionSlug, DASHBOARD_ROUTE.dashboard); // dashboard = "/homeowners"
    }
}
